import { useQuery, NetworkStatus } from '@apollo/client'

import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { Box } from '@grupoboticario/flora-react'

import NewAcceleratorButton from '@/components/NewAcceleratorButton/NewAcceleratorButton'
import AccelerationTable from '@/components/Table/AccelerationTable/AccelerationTable'
import GET_LIST_CAMPAIGNS from '@/graphql/queries/listCampaigns'

import * as P from '../pages.styles'

const AccelerationPage = () => {
  const [pagination, setPagination] = useState({ limit: 10, nextPage: '' })
  const [searchParams] = useSearchParams()

  const { loading, refetch, data, networkStatus } = useQuery(GET_LIST_CAMPAIGNS, {
    variables: {
      limit: pagination.limit,
      nextPage: pagination.nextPage
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true
  })

  const isLoading = loading || networkStatus === NetworkStatus.refetch

  useEffect(() => {
    if (searchParams.get('refresh')) refetch()
  }, [refetch, searchParams])

  return (
    <Box css={P.pageWrapperCss}>
      <NewAcceleratorButton label="Cadastrar novo acelerador" />

      <AccelerationTable
        data={data?.listCampaigns || { items: [] }}
        loading={isLoading}
        onPaginationChange={(pagination) => setPagination(pagination)}
        refetch={refetch}
      />
    </Box>
  )
}

export { AccelerationPage }
